// ======================================================================
// FILE:
// src/modules/finance/services/generalLedgerService.js
//
// MODULE:
// Finance & Accounts Management System (FBAMS)
//
// FEATURE:
// General Ledger
//
// PURPOSE:
// Frontend API client for General Ledger inquiry.
//
// IMPORTANT:
// - API calls only
// - No React code
// - No UI logic
// - No navigation
// - No state management
// ======================================================================

import axiosClient
from "../../../api/axiosClient";

const BASE_URL =
    "/api/finance/general-ledger";


// ======================================================================
// GENERAL LEDGER SUMMARY
// ======================================================================

async function getGeneralLedger(
    params = {}
) {

    const response =
        await axiosClient.get(
            BASE_URL,
            {
                params,
            }
        );

    return response.data.data;
}


// ======================================================================
// ACCOUNT LEDGER
// ======================================================================

async function getAccountLedger(
    params = {}
) {

    const response =
        await axiosClient.get(
            `${BASE_URL}/account`,
            {
                params,
            }
        );

    return response.data.data;
}


// ======================================================================
// EXPORT
// ======================================================================

const generalLedgerService = {

    getGeneralLedger,

    getAccountLedger,

};

export default generalLedgerService;